// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".navbar-dark .navbar-nav .nav-link{position:relative;font-weight:700;display:block;margin:0 8px}.navbar-dark .navbar-nav .nav-link:after{content:\"\";display:block;width:0;height:2px;background:#fff;transition:width .5s linear}.navbar-dark .navbar-nav .nav-link:hover:after{width:100%}.navbar-dark .navbar-nav .nav-link span{position:relative;display:block;padding:8px 0}", ""]);
// Exports
module.exports = exports;
